import { Claim, MaskedLine, Micro, Reveal, SlideBody, SlideShell } from "../shared";
import { IMG } from "../images";

const ALTS = [
  "Villa luxury con piscina al tramonto",
  "Interno mediterraneo di una villa",
  "Piscina a sfioro con vista oceano",
  "Tavola fine dining in terrazza",
];

const Frame = ({ src, alt, className = "", delay = 0 }) => (
  <Reveal delay={delay} className={className}>
    <div className="group h-full w-full overflow-hidden">
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
    </div>
  </Reveal>
);

export default function Slide05Collection() {
  const [a, b, c, d] = IMG.collection;
  return (
    <SlideShell theme="navy" testid="slide-5-collection">
      <SlideBody>
        <div className="grid items-center gap-12 lg:grid-cols-[1fr_1.15fr]">
          <div>
            <Reveal>
              <Micro>04 · La Collection</Micro>
            </Reveal>
            <h2 className="mt-5 font-serif text-4xl leading-[1.04] tracking-tight sm:text-5xl">
              <MaskedLine delay={0.1}>LA PRIMA COLLECTION:</MaskedLine>
              <MaskedLine delay={0.22}>
                <em className="italic text-[#D4AF37]">20 VILLE.</em>
              </MaskedLine>
            </h2>
            <Reveal delay={0.45}>
              <p className="mt-8 max-w-md font-serif text-xl italic leading-snug text-[#94A3B8] sm:text-2xl">
                «Le 20 ville più belle della Costiera Amalfitana.»
              </p>
            </Reveal>
            <Reveal delay={0.6} className="mt-8">
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
                Positano · Ravello · Amalfi · Praiano
              </span>
            </Reveal>
            <Reveal delay={0.7} className="mt-6">
              <Claim>Curated, not listed.</Claim>
            </Reveal>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="flex flex-col gap-3 pt-10">
              <Frame src={a} alt={ALTS[0]} delay={0.35} className="h-52 lg:h-60" />
              <Frame src={c} alt={ALTS[2]} delay={0.55} className="h-44 lg:h-52" />
            </div>
            <div className="flex flex-col gap-3">
              <Frame src={b} alt={ALTS[1]} delay={0.45} className="h-44 lg:h-52" />
              <Frame src={d} alt={ALTS[3]} delay={0.65} className="h-52 lg:h-60" />
            </div>
          </div>
        </div>
      </SlideBody>
    </SlideShell>
  );
}
